import { PickUpResponseModel, AllPickUpResponseModel } from '@gtpl/shared-models/hrms'
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PickUpDTO } from './dto/pickup.dto';
import { PickUpRequest } from './dto/pickup.request';
import { PickUpService } from './pickup.service';

@ApiTags('pickUp')
@Controller('pickUp')
export class PickUpController {

    constructor(
        private service: PickUpService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createPickUp')
    async createPickUp(@Body() DTO: PickUpDTO, isUpdate: boolean = false): Promise<PickUpResponseModel>{
        try{
            return await this.service.createPickUp(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(PickUpResponseModel, error);
        }
    }

    @Post('/updatePickUp')
    async updatePickUp(@Body() DTO: PickUpDTO, isUpdate: boolean = false): Promise<PickUpResponseModel>{
        try{
            return await this.service.createPickUp(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(PickUpResponseModel, error);
        }
    }

    @Post('/getAllPickUp')
    async getAllPickUp(): Promise<AllPickUpResponseModel>{
        try{
            return await this.service.getAllPickUp();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllPickUpResponseModel, error);
        }
    }

    @Post('/getAllActivePickUp')
    async getAllActivePickUp(): Promise<AllPickUpResponseModel>{
        try{
            return await this.service.getAllActivePickUp();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllPickUpResponseModel, error);
        }
    }

    @Post('/activateOrDeactivatePickUp')
    async activateOrDeactivatePickUp(@Body() pickUpReq: PickUpRequest): Promise<PickUpResponseModel>{
        try{
            return await this.service.activateOrDeactivatePickUp(pickUpReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(PickUpResponseModel, error);
        }
    }
}